import React, {Component} from 'react'
import {Line} from 'react-chartjs-2'
import * as PropTypes from "prop-types";
import Paper from "@material-ui/core/Paper";
import MuiTable from "../common/MuiTable";
import {organisationDetails, saveOrUpdateOrganisationDetails} from "../../util/ApiUtils";
import { t } from '../../i18n';
import {NotificationManager} from 'react-notifications';
import * as CommonUtils from "../../util/CommonUtils";

const options = {
    scales: {
        yAxes: [{
            scaleLabel: {
                display: true,
                labelString: t('leadership.customerComplaints.chart.yLabel')
            },
            ticks: {
                min: 0
            }
        }],
        xAxes: [{
            scaleLabel: {
                display: true,
                labelString: t('leadership.customerComplaints.chart.xLabel')
            }
        }],
    }
}

function createChartData() {
    return {
        labels: [],
        datasets: [
            {
                label: t('menu.leadership.customerComplaints'),
                fill: false,
                backgroundColor: '#1a73e8',
                borderColor: 'rgba(255,99,132,1)',
                borderWidth: 1,
                hoverBackgroundColor: 'rgba(255,99,132,0.4)',
                hoverBorderColor: 'rgba(255,99,132,1)',
                data: []
            }
        ]
    };
}

const months = { 1: 'Jan', 2: 'Feb', 3: 'Mar', 4: 'Apr', 5: 'May', 6: 'Jun', 7: 'Jul', 8: 'Aug', 9: 'Sep', 10: 'Oct', 11: 'Nov', 12: 'Dec' };

const muiColumns = [
    {
        title: t('leadership.customerComplaints.columns.id'),
        field: 'id',
        type: "numeric",
        hidden: true,
    },
    { title: t('leadership.customerComplaints.columns.month'), field: 'month', lookup: { 'Jan': t('months.Jan'), 'Feb': t('months.Feb'), 'Mar': t('months.Mar'), 'Apr': t('months.Apr'), 'May': t('months.May'), 'Jun': t('months.Jun'), 'Jul': t('months.Jul'), 'Aug': t('months.Aug'), 'Sep': t('months.Sep'), 'Oct': t('months.Oct'), 'Nov': t('months.Nov'), 'Dec': t('months.Dec') }},
    { title: t('leadership.customerComplaints.columns.year'), field: 'year'},
    { title: t('leadership.customerComplaints.columns.noOfComplaints'), field: 'noOfComplaints', headerStyle: { width: "50%" } },
];

class CustomerComplaints extends Component {

    constructor(props) {
        super(props);
        this.state = {
            organisation: { customerComplaints: [] },
            orgId: null,
            customerComplaints: [],
            chartData: createChartData(),
            isLoading: true
        };
        this.loadOrganisationDetails = this.loadOrganisationDetails.bind(this);
        this.isValid = this.isValid.bind(this);
        this.handleAdd = this.handleAdd.bind(this);
        this.handleDelete = this.handleDelete.bind(this);
        this.handleUpdate = this.handleUpdate.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    componentDidMount() {
        this.loadOrganisationDetails();
    }

    loadOrganisationDetails() {
        organisationDetails()
            .then(response => {
                console.log('organisation response', response);
                let organisation = response || {};
                let sorted = (organisation.customerComplaints || []).slice().sort(function(a, b) {
                    let am = Object.keys(months).find(key => months[key] === a.month)
                    let bm = Object.keys(months).find(key => months[key] === b.month)
                    return a.year - b.year || am - bm;
                });
                console.log('sorted complaints', sorted);
                let chartData = createChartData();
                sorted.forEach((element) => {
                    // Use translated month label when available
                    const monthLabelKey = `months.${element.month}`;
                    let monthLabel = t(monthLabelKey);
                    // If translation returns the key back (not found), fall back to element.month
                    if (monthLabel === monthLabelKey) {
                        monthLabel = element.month;
                    }
                    chartData.labels.push(`${monthLabel} ${element.year}`)
                    chartData.datasets[0].data.push(element.noOfComplaints)
                })
                this.setState({
                    organisation: Object.assign({}, organisation, { customerComplaints: sorted }),
                    orgId: organisation.id,
                    customerComplaints: sorted,
                    chartData: chartData,
                    isLoading: false
                });
            })
            .catch(error => {
                console.log(error);
            });
    }

    isValid(newData) {
        let isValid = newData.month && newData.month !== '' && newData.year && newData.year !== '' && newData.noOfComplaints && newData.noOfComplaints !== '';
        if (!isValid) {
            NotificationManager.error(t('app.notifications.error'), t('messages.validationErrorFields'), 5000);
        }
        return isValid;
    }

    handleUpdate(toUpdate) {
        console.log("updating to ", toUpdate);
        for (let i = 0, l = this.state.organisation.customerComplaints.length; i < l; i++) {
            if (this.state.organisation.customerComplaints[i].id === toUpdate.id) {
                this.state.organisation.customerComplaints[i].month = toUpdate.month;
                this.state.organisation.customerComplaints[i].year = toUpdate.year;
                this.state.organisation.customerComplaints[i].noOfComplaints = toUpdate.noOfComplaints;
            }
        }
        console.log("After update:", this.state.organisation.customerComplaints);
        this.handleSubmit(this.state.organisation.customerComplaints);
    }

    handleDelete(toDelete) {
        let customerComplaints = [];
        const index = this.state.organisation.customerComplaints.findIndex(x => x.id === toDelete.id);
        for (let i = 0, l = this.state.organisation.customerComplaints.length; i < l; i++) {
            if (i !== index) {
                customerComplaints.push(this.state.organisation.customerComplaints[i]);
            }
        }
        console.log("After removal:", customerComplaints);
        this.handleSubmit(customerComplaints);
    }

    handleAdd(data) {
        this.state.organisation.customerComplaints.push(data);
        this.handleSubmit(this.state.organisation.customerComplaints);
    }

    handleSubmit(data) {
        this.state.organisation.customerComplaints = data;
        saveOrUpdateOrganisationDetails(this.state.organisation)
            .then(() => {
                NotificationManager.success(t('app.notifications.success'), t('messages.dataUpdated'), 5000);
                this.loadOrganisationDetails();
                this.props.onChanged(this.state.organisation.customerComplaints);
            }).catch(error => {
            console.log("error");
            console.log(error);
            NotificationManager.error(t('app.notifications.error'), t('messages.genericError'), 5000);
        });
    }

    render() {
        let isAuditor = CommonUtils.isAuditor(this.props.currentUser);
        let isViewer = CommonUtils.isViewer(this.props.currentUser);
        if (this.state.isLoading) {
            return null;
        }
        return (
        // A react-chart hyper-responsively and continuously fills the available
        // space of its parent element automatically
        <div>
            {this.props.isEdit ?
                <React.Fragment>
                    <Paper style={{ marginTop: '30px' }}>
                        <MuiTable
                            title={ t('menu.leadership.customerComplaints') }
                            columns={muiColumns}
                            data={this.state.customerComplaints}
                            onAdd={this.handleAdd}
                            onUpdate={this.handleUpdate}
                            onDelete={this.handleDelete}
                            isValid={this.isValid}
                            exportButton={false}
                            search={false}
                            pageSize={20}
                            headerStyle={{ background: "lightblue" }}
                            allowUpdateDelete={(isAuditor || isViewer) ? 'no' : 'yes'}
                        />
                    </Paper>
                </React.Fragment>
            :
            <Line
                data={this.state.chartData}
                width={400}
                height={300}
                options={options}
                redraw
            />}
        </div>
    )};
}

CustomerComplaints.propTypes = {
    isEdit: PropTypes.bool.isRequired,
    onChanged: PropTypes.func.isRequired,
}
export default CustomerComplaints;